module.exports = __webpack_public_path__ + "img/transaction_intro_02@2x.689099d4.png";